import { api } from "@/services/api"
import { useQuery } from "@tanstack/react-query"

export type PayloadProps = {
    "codigoPedido"?: string,
    "dataFim": string,
    "dataInicio": string,
    "produto"?: string,
    "situacao"?: string
}

export type Response = {
    "skus": {
        "porcentagem": number,
        "processado": number,
        "total": number
    },
    "totalConcluido": {
        "porcentagem": number,
        "processado": number,
        "total": number
    },
    "totalDivergente": {
        "porcentagem": number,
        "processado": number,
        "total": number
    },
    "totalPendente": {
        "porcentagem": number,
        "processado": number,
        "total": number
    }
}

export type ResumeHook = {
    refetch: any,
    data: Response | undefined,
    isLoading: boolean
}

export const useResume = ({ body }: { body: PayloadProps }) => {
    
    const { data, isLoading, refetch } = useQuery({
        queryKey: ['auditoria-pedidos', JSON.stringify(body)],
        queryFn: async () => await api.post<Response>('acompanhamento/auditoria/expedicao/resumo', body),
        select: data => data.data
    })

    return {
        refetch: refetch as any,
        data,
        isLoading
    }
}